import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _DefaultCookieDomains2, _process$env$CHEGG_EN, _CookieToDomain;
import { CheggEnv } from '../getCheggEnv';
import rewriteCheggTldToMatch from '../urls/rewriteCheggTldToMatch';
import { CookieName } from './constants';

/**
 * DO NOT export and use these DEFAULT_COOKIE_DOMAIN constants directly.
 * Cookie domains for international pages need to be rewritten to match
 * the runtime hostname context.
 */
var DefaultCookieDomains = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, CheggEnv.PROD, '.chegg.com'), CheggEnv.STAGE, '.test.cheggnet.com'), CheggEnv.TEST, '.test.cheggnet.com'), CheggEnv.DEV, '.test.cheggnet.com'), "TEST_OPTIMIZELY", '.cheggnet.com');
var DEFAULT_COOKIE_DOMAIN = (_DefaultCookieDomains2 = DefaultCookieDomains[(_process$env$CHEGG_EN = process.env.CHEGG_ENV) !== null && _process$env$CHEGG_EN !== void 0 ? _process$env$CHEGG_EN : '']) !== null && _DefaultCookieDomains2 !== void 0 ? _DefaultCookieDomains2 : DefaultCookieDomains[CheggEnv.DEV];
var CookieToDomain = (_CookieToDomain = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_CookieToDomain, CookieName.ACCESS_TOKEN, DEFAULT_COOKIE_DOMAIN), CookieName.CLOUDFRONT_COUNTRY_CODE, DEFAULT_COOKIE_DOMAIN), CookieName.COUPON_CODE, DEFAULT_COOKIE_DOMAIN), CookieName.EC_UPLOAD_PENDING, DEFAULT_COOKIE_DOMAIN), CookieName.EXP_UAE, DEFAULT_COOKIE_DOMAIN), CookieName.EXP_AA, DEFAULT_COOKIE_DOMAIN), CookieName.EXPERIMENT_IDENTIFIER, process.env.CHEGG_ENV === CheggEnv.TEST ? DefaultCookieDomains.TEST_OPTIMIZELY : DEFAULT_COOKIE_DOMAIN), CookieName.ID_TOKEN, DEFAULT_COOKIE_DOMAIN), CookieName.JERICHO_SESSION, DEFAULT_COOKIE_DOMAIN), CookieName.LANG_PREFERENCE, DEFAULT_COOKIE_DOMAIN), _defineProperty(_defineProperty(_defineProperty(_CookieToDomain, CookieName.OPT_USER_PROFILE, process.env.CHEGG_ENV === CheggEnv.TEST ? DefaultCookieDomains.TEST_OPTIMIZELY : DEFAULT_COOKIE_DOMAIN), CookieName.ORDER_REDIRECT, DEFAULT_COOKIE_DOMAIN), CookieName.PREVIOUS_TRUEX, DEFAULT_COOKIE_DOMAIN));

/**
 * This function determines what domain should be used when writing a cookie.
 * - Passing undefined cookie name is equivalent to getting the default
 *   cookie domain.
 * - Passing a cookie name uses the explicit domain mappings for lookup and
 *   allows override logic for special cases such as Optimizely cookies.
 *   If no mapping is found, undefined is returned to indicate that the
 *   specified name was explicitly not included in the domain mappings.
 * - Passing undefined cookie context skips international TLD rewriting.
 * - Passing a cookie context will trigger TLD rewriting of the domain for
 *   international context cookies.
 *
 * Usage:
 * - getCookieDomain()
 *   => DEFAULT_COOKIE_DOMAIN in US context
 * - getCookieDomain(undefined, 'www.chegg.com.mx')
 *   => DEFAULT_COOKIE_DOMAIN in MX context
 * - getCookieDomain('access_token')
 *   => specific cookie domain mapping in US context
 * - getCookieDomain('V', 'www.chegg.com.mx')
 *   => optimizely cookie domain in MX context
 * - getCookieDomain('unrecognized_cookie')
 *   => undefined
 *
 * @param name
 * @param context
 * @returns string | undefined
 */
function getCookieDomain(name, context) {
  var domain = name ? CookieToDomain[name] : DEFAULT_COOKIE_DOMAIN;
  return rewriteCheggTldToMatch(domain, context);
}
export default getCookieDomain;